import * as React from "react";
import { Create, Form, SaveButton, TextInput, useGetList, AutocompleteArrayInput, BooleanInput, SelectInput } from "react-admin";
import { Grid, Typography, Avatar, CssBaseline } from '@mui/material';
import RedeemIcon from '@mui/icons-material/Redeem';

import { validatePhoneNumber } from "../utils/validation";

export const UserCreate = () => {
    const { data } = useGetList(
        'groups',
        {
            pagination: { page: 1, perPage: 60 },
            sort: { field: 'createdAt', order: 'DESC' }
        }
    );
    const { profileData } = useGetList(
        'profiles',
        {
            pagination: { page: 1, perPage: 60 },
        }
    )

    const groupChoices = data ? data.map(item => ({ id: item.id, name: item.group })) : [];
    const profileChoices = profileData ? profileData.map(item => ({ id: item.id, name: item.name })) : [];

    return (
        <Create title="Invite User" redirect="show">
            <CssBaseline />
            <div style={{
                margin: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
            }}>
                <div style={{
                    paddingBottom: "4em",
                }} >
                    <Avatar>
                        <RedeemIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Invite User
                    </Typography>
                </div>
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={5} md={5} lg={4}>
                            <TextInput
                                variant="outlined"
                                required
                                fullWidth
                                label="Email Address"
                                type="email"
                                source="email"
                                autoComplete="email"
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={5} md={5} lg={4}>
                            <TextInput
                                variant="outlined"
                                required
                                fullWidth
                                label="Temporary Password"
                                source="password"
                                validate={validatePassword}
                            />
                        </Grid> */}
                        <Grid item xs={0} sm={6} md={6} lg={8} />
                        <Grid item xs={12} sm={5} md={5} lg={4}>
                            <TextInput
                                variant="outlined"
                                fullWidth
                                label="First Name"
                                source="given_name"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={5} md={5} lg={4}>
                            <TextInput
                                variant="outlined"
                                fullWidth
                                label="Last Name"
                                source="family_name"
                                required
                            />
                        </Grid>
                        <Grid item xs={0} sm={1} md={1} lg={0} />
                        <Grid item xs={12} sm={5} md={5} lg={4}>
                            <TextInput
                                variant="outlined"
                                fullWidth
                                source="phone_number"
                                validate={validatePhoneNumber}
                            />
                        </Grid>
                        <Grid item xs={12} sm={5} md={5} lg={4}>
                            <BooleanInput
                                fullWidth
                                label="Enable SMS MFA"
                                source="sms_mfa_enabled"
                            />
                        </Grid>
                        <Grid item xs={0} sm={1} md={1} lg={0} />
                        <Grid item xs={12} sm={5} md={5} lg={4}>
                            <AutocompleteArrayInput
                                outlined label="Application" source="groups" choices={groupChoices} required />
                        </Grid>
                        <Grid item xs={12} sm={5} md={5} lg={4}>
                            <SelectInput
                                outlined label="Company" source="profile" choices={profileChoices} required />
                        </Grid>
                        <Grid item xs={12}>
                            <BooleanInput
                                source="notify"
                                label="Send an invitation email to user now"
                                fullWidth
                                defaultValue={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container justify="flex-end">
                        <Grid item xs={4} >
                            <SaveButton
                                label="Invite"
                            />
                        </Grid>
                    </Grid>
                </Form>
            </div>
            <CssBaseline />
        </Create >
    );
}